const config = [
    {
        title: 'dashboard',
        path: '/dashboard',
        iconType: 'dashboard',
        code: '01',
        children: [],
        hidden: true,
        index: '01',
    },
    {
        title: 'alarmCenter',
        path: '/alarmCenter',
        iconType: 'alert-center',
        code: '02',
        children: [],
        hidden: true,
        index: '02',
    },
    {
        title: 'fileCluster',
        path: '/fileCluster',
        iconType: 'file-cluster',
        code: '10',
        children: [],
        hidden: true,
        index: '10',
    },
    {
        title: 'task',
        path: '/tasklist',
        iconType: 'task-monitor',
        code: '03',
        children: [],
        hidden: true,
        index: '03',
    },
    {
        title: 'monitoringCenter',
        path: '/monitoringCenter',
        iconType: 'monitoring-icon',
        code: '06',
        children: [],
        hidden: true,
        index: '06',
    },
    {
        title: 'recordCenter',
        path: '/recordCenter',
        iconType: 'record-icon',
        code: '09',
        children: [],
        hidden: true,
        index: '09',
    },
    {
        title: 'intelligentSearch',
        path: '/search',
        iconType: 'search-icon',
        code: '04',
        children: [],
        hidden: true,
        index: '04',
    },
    {
        title: 'tools',
        path: '/tools',
        iconType: 'tools',
        code: '07',
        children: [],
        hidden: true,
        index: '07',
    },
    {
        title: 'dataMining',
        path: '/dataMining',
        iconType: 'big-data',
        code: '11',
        children: [],
        hidden: true,
        index: '11',
    },
    {
        title: 'portraitCenter',
        path: '/portraitCenter',
        iconType: 'portrait-center',
        code: '08',
        children: [],
        hidden: true,
        index: '08',
    },
];
export default config;
